export default __webpack_public_path__ + "static/media/template.c26d6fa9.svg";